import Withdrawal from "@/pages/purseSetting/withdrawal/withdrawal.vue";
import Binding from "@/pages/purseSetting/binding/binding.vue";
import Record from "@/pages/purseSetting/record/record.vue";
import Detail from "@/pages/purseSetting/record/index.vue";
import layout from "@/components/layout/layout";

// 2022-06-27 新增连连钱袋 可以沿用该（r4gys）角色判断
const purseSet = {
  path: "/account",
  component: layout,
  meta: { roles: ["r4gys"], title: "账户设置", icon: "icon-setting-user" },
  children: [
    {
      path: "/purse/binding",
      component: Binding,
      name: "purseBinding",
      meta: { roles: ["r4gys"], title: "绑定" }
    },
    {
      path: "/purse/withdrawal",
      component: Withdrawal,
      name: "purseWithdrawal",
      meta: { roles: ["r4gys"], title: "提现" }
    },
    {
      path: "/purse/withdrawal/detail",
      component: Detail,
      name: "purseDetail",
      hidden: true,
      meta: { roles: ["r4gys"], title: "提现明细" }
    }
    // {
    //   path: "/purse/detail",
    //   component: Record,
    //   name: "purseRecord",
    //   meta: { roles: ["r4gys"], title: "交易明细" }
    // }
  ]
};
export default purseSet;



// WEBPACK FOOTER //
// ./src/router/modules/purseSet.js